import { InjectionToken } from '@angular/core';

// Reloads the whole application at its root so no in-memory state survives. Behind a token so
// tests can observe it without reloading the page.
export const RELOAD_APP = new InjectionToken<() => void>('RELOAD_APP', {
  providedIn: 'root',
  factory: () => () => window.location.assign('/'),
});
